module.exports = __webpack_public_path__ + "static/media/investor-banner.1f13ebe2.png";